import { API_MELI_INTEGRATION_URL } from './servers';

export const MELI_INTEGRATION_API_KEY = 'sk_prod_a8Fv29LmQx7NwP4tYcK1ZhD6sRjU3eB5gHpM9XnT2qV7cLfW0uYsE4iAkR8d';

export const fetchMeliIntegration = async <T,>(path: string) => {
  try {
    const response = await fetch(`${API_MELI_INTEGRATION_URL}${path}`, {
      headers: { 'x-api-key': MELI_INTEGRATION_API_KEY },
    });
    if (!response.ok) {
      return { error: { status: response.status, data: await response.text() } };
    }
    return { data: (await response.json()) as T };
  } catch (error) {
    return {
      error: {
        status: 'FETCH_ERROR' as const,
        error: error instanceof Error ? error.message : 'Error de conexión',
      },
    };
  }
};
